import { error, finish } from '../../../modules/market-templates/actions/move';
import api from '../../../api';

export function request(dispatch, { sportId, list }) {
    api.post(
        `/sports/${sportId}/event-templates/market-templates/move`,
        { list }
    )
        .then(
            marketTemplates => dispatch(finish(marketTemplates)),
            errors => dispatch(error(errors))
        );
}
